import { put, select, takeLatest } from 'redux-saga/effects';

import { SUCCESS_PATH } from 'checkout/store/constants';

import {
  orderProcessedAction,
  prebuildOrderAction,
  submitPackageAction,
  toggleInsuranceAction,
} from 'checkout/store/actions/order';
import { goToPathAction, goToPayAction } from 'checkout/store/actions/view';
import {
  handleSubmitManual,
  handleSubmitWithUpdate,
  sendOrderPaymentStarted,
} from 'checkout/store/sagas/order';

import { getIsManualPackage } from 'checkout/store/selectors/package';
import { validationSuccessAction } from 'checkout/store/validation/actions';

/**
 * Обрабатывает сабмит заказа
 * - при необходимости, проверяет актуальность цены
 * - создает заказ, если еще не создан
 * - иначе дергает оплату
 */
function* handleSubmitOrder() {
  const isManualPackage = yield select(getIsManualPackage);
  if (isManualPackage) {
    yield handleSubmitManual();
  } else {
    yield handleSubmitWithUpdate();
  }

  // Аналитика клика по кнопке оплаты
  yield sendOrderPaymentStarted();
}

// Client and tourist
function* confirmTourists() {
  yield put(goToPayAction());
  yield put(prebuildOrderAction());
}

/**
 * Переходим на страницу успеха
 */
function* finishOrder() {
  yield put(goToPathAction(SUCCESS_PATH));
}

function* handleToggleInsurance() {
  yield put(prebuildOrderAction());
}

export default function* checkoutOrderWatcher() {
  yield takeLatest(submitPackageAction, handleSubmitOrder);
  yield takeLatest(validationSuccessAction, confirmTourists);
  yield takeLatest(orderProcessedAction, finishOrder);
  yield takeLatest(toggleInsuranceAction, handleToggleInsurance);
}
